<db-loading-screen [loadingMessage]="templateId ? 'Please wait while template importing.' : 'Please wait while website is created.'" [pageBlocker]="true" [fullSize]="true"></db-loading-screen>
